import React, { useEffect, useRef, useState } from 'react';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Button, Snackbar, Alert } from '@mui/material';
import axios from 'axios'
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

import {BarLoader, GridLoader, HashLoader, MoonLoader, PropagateLoader, PuffLoader, PulseLoader} from 'react-spinners'
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import SendIcon from '@mui/icons-material/Send';
import PrintIcon from '@mui/icons-material/Print';

function Returns() {
  // State for managing selected invoice, detailed view, and final total
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedIncoiceDetails,setSelectedInvoiceDetails] = useState([]);
  const [invoices,setInvoices] = useState([])
  const [remainingQty, setRemainingQty] = useState(0); 
  const [pending,setPending] = useState(0)
  const [alertOpen,setAlertOpen] = useState(false)
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
  const [drawDate,setdrawDate] = useState(getCurrentDate())


  const [updatedInvoice, setUpdatedInvoice] = useState(null);
  const [finalTotal, setFinalTotal] = useState(0);

  const [loading,setLoading]= useState(true)
  const [selectedLoading,setSelectedLoading]= useState(false)
  const [submitLoading,setSubmitLoading]= useState(false)


  const navigate = useNavigate();

  
  const currentTime = new Date();
  const hours = formatTwoDigits(currentTime.getHours());
  const minutes = formatTwoDigits(currentTime.getMinutes());
  const seconds = formatTwoDigits(currentTime.getSeconds());
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = formatTwoDigits(currentDate.getMonth() + 1); 
  const day = formatTwoDigits(currentDate.getDate());
  const hour = formatTwoDigits(currentDate.getHours());
  const minute = formatTwoDigits(currentDate.getMinutes());
  const second = formatTwoDigits(currentDate.getSeconds());




const getTomorrowDate = () => {
  const today = new Date();
  // Add one day to the current date
  today.setDate(today.getDate() + 1);
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


const handleClose = (event, reason) => {
  if (reason === 'clickaway') {
      return;
  }
  setAlertOpen(false);
};


const printsRef = useRef()

const handlePrints = useReactToPrint({
  content: () => printsRef.current,
  pageStyle: `
  @page {
    width: 80mm; 
    height: 1000mm;
    margin-top: 0cm; 
    margin-right:5mm;
    margin-bottom: 0cm;
    margin-left: 0cm;
  }
  `,
})

  
function formatTwoDigits(value) {
  return value < 10 ? `0${value}` : value;
}






useEffect(() => {
    
  axios.get("https://servermunidasa.ccsoftwares.com/settle/getAllPendings").then(res =>{
    console.log(res.data)
    setInvoices(res.data)
    setLoading(false)
  })





}, [])


  const getHeader = ()=>{
    axios.get("https://servermunidasa.ccsoftwares.com/settle/getAllPendings").then(res =>{
      console.log(res.data)
      setInvoices(res.data)
      setLoading(false)
    })

  }

  const getInvoiceDetails = (inv)=>{
    const data = {inv_no :inv.inv_no }
    axios.post("https://servermunidasa.ccsoftwares.com/ticketOut/getTIckctByInvoice",data).then(res =>{
      console.log(res.data)
      setSelectedInvoiceDetails(res.data)
      setSelectedLoading(true)
      axios.post("https://servermunidasa.ccsoftwares.com/settle/getPendingDistributor",{distKey:res.data[0].distributorId}).then(res =>{
        setPending(res.data[0].pending || 0.00)
        console.log(res.data[0].pending|| 0.00)
        setSelectedLoading(false)
      })
    })
    



  }
  

  const handleInvoiceSelect = (invoice) => {
    console.log(invoice)
    setSelectedLoading(true)
    setSelectedInvoice(invoice);
    getInvoiceDetails(invoice)
  };

  const handleQtyChange = (index, newReturnQty) => {
    const newItems = [...selectedIncoiceDetails];
  
    newItems[index].returnQty = newReturnQty !== undefined && newReturnQty !== null ? newReturnQty : 0;
    newItems[index].returnQty = newItems[index].returnQty > newItems[index].qty ? newItems[index].qty : newItems[index].returnQty;
    newItems[index].remainingQty = newItems[index].qty - newItems[index].returnQty;
    newItems[index].calculatedTotal = newItems[index].remainingQty * newItems[index].unitPrice;
    setSelectedInvoiceDetails(newItems);
    calculateTotal(newItems);
  };

const calculateTotal = (items) => {
  const total = items.reduce((sum, item) => sum + (item.calculatedTotal || 0), 0);
  const remainingTotalQty = items.reduce((sum, item) => sum + (item.remainingQty || 0), 0);

  setFinalTotal(total);
  setRemainingQty(remainingTotalQty); 
};
  // State for the filter input
  const [filter, setFilter] = useState('');

  // Filter invoices based on the inv_no
  // const filteredInvoices = invoices.filter(invoice =>
  //   invoice.inv_no.toLowerCase().includes(filter.toLowerCase()) || invoice.distributor.toLowerCase().includes(filter.toLowerCase())
  // );

  const filteredInvoices = invoices.filter(invoice => 
    (invoice.inv_no.toLowerCase().includes(filter.toLowerCase()) ||
     invoice.distributor.toLowerCase().includes(filter.toLowerCase())) &&
    (!drawDate || invoice.draw_date.split('T')[0] === drawDate) // Check if drawDate matches
  );

  const clearFilters = () => {
    setFilter('');
    setdrawDate(''); // Set drawDate to an empty string to remove date filtering
  };


  const handlePrint = async () => {

    const confirm = window.confirm("This action is irreversible, make sure to fill all the return values.");

    if (confirm) {
      setSubmitLoading(true); 
    
      console.log('Selected invoice details:', selectedIncoiceDetails);
    
      const header = {
        qty: remainingQty,
        Tickettotal: finalTotal,
        headerkey: selectedInvoice.headerKey
      };
    
      console.log('Header:', header);
    
      try {
        // Make sure the API calls are awaited properly
        const response = await axios.put("https://servermunidasa.ccsoftwares.com/ticketOut/updateTicketOut", { items: selectedIncoiceDetails });
        const response2 = await axios.put("https://servermunidasa.ccsoftwares.com/ticketOut/updateHeader", header);
        const response3 = await axios.put("https://servermunidasa.ccsoftwares.com/stock/returnStock", selectedIncoiceDetails);
    
        // Show success alert
        setAlertOpen(true);
    
        // Handle print after API responses
        handlePrints();
    
        // Reload the page after successful completion of all API calls
      } catch (error) {
        // Display error message if API calls fail
        alert(error.message);
      } finally {
        // Ensure loading state is reset and getHeader is called
       await getHeader();
        setSubmitLoading(false);
      }
    }
};

  return (
    <Grid container spacing={2} style={{ padding: '20px' }}>
      {/* First Column: List of Invoice Headers */}
      <Grid xs = {12} md = {12}>
            <div style={{display : 'flex',alignItems : 'center',justifyContent : 'left',height : 40}}>
            <button
            style={{
                    backgroundColor : 'transparent',
                    color: 'Black',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 30,
                    marginTop : 10
                }}
                onClick={() => navigate(-1)}
            >
          <ArrowCircleLeftIcon fontSize='2'/>
        </button>
            <div style={{fontFamily : 'Segoe UI',fontSize : 28,fontWeight : '400'}}>
                Ticket Returns
            </div>
        </div>

        </Grid>
        <Grid item xs={12} md={4}>
      <Paper style={{ padding: '20px', height: '100%' }}>
        <h3>Invoice List</h3>
        <Grid container spacing={2}>

        <Grid md = {4}>

        <TextField
          label="Filter by Invoice No | Distributor Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          />
          </Grid>
        <Grid md = {4}>

        <TextField
          variant="outlined"
          type="date"
          fullWidth
          margin="normal"
          value={drawDate}
          onChange={(e) => setdrawDate(e.target.value)}
          style={{marginLeft : 20}}
          />
          </Grid>
          <Grid md = {4}>

            <Button
              variant="outlined"
              color="secondary"
              onClick={clearFilters}
              style={{ marginTop: 25, marginBottom: 10, marginLeft: 40}}
              >
              Clear
          </Button>
        </Grid>
          </Grid>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Distributor</TableCell>
                <TableCell>Draw Date</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Invoice No</TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={4}>
                    <center><HashLoader size={30} color='black' style={{ marginLeft: 20 }} /></center></TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {filteredInvoices.map((invoice) => (
                  <TableRow key={invoice.inv_no} hover onClick={() => handleInvoiceSelect(invoice)}>
                    <TableCell>{invoice.distributor}</TableCell>
                    <TableCell>{invoice.draw_date.split('T')[0]}</TableCell>
                    <TableCell>{invoice.total}</TableCell>
                    <TableCell>{invoice.inv_no}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
      {/* Second Column: Invoice Details with Editable Qty */}
      <Grid item xs={12} md={4}>
        <Paper style={{ padding: '20px', height: '100%' }}>
          <h3>Invoice Details</h3>
          {selectedIncoiceDetails ? (
            <>
              <p><strong>Invoice No:</strong> {selectedInvoice?.inv_no}</p>
              <p><strong>Distributor:</strong> {selectedInvoice?.distributor}</p>
              <p><strong>Draw Date:</strong> {selectedInvoice?.draw_date.split('T')[0]}</p>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{fontWeight : '600'}}>Lottery</TableCell>
                      <TableCell style={{fontWeight : '600'}}>Issued</TableCell>
                      <TableCell style={{fontWeight : '600'}}>Returned</TableCell>
                      <TableCell style={{textAlign : 'right',fontWeight : '600'}}>Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedLoading ? (
                      <center><HashLoader size={30} color='black' style={{ marginLeft: 20 }} /></center>
                    ) : (
                      selectedIncoiceDetails.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.Lottery}</TableCell>
                          <TableCell style={{textAlign : 'center'}}>{item.qty}</TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              // value={item.qty}
                              onChange={(e) => handleQtyChange(index, parseInt(e.target.value))}
                              style={{ width: '60px' }}
                            />
                          </TableCell> 
                          <TableCell style={{ textAlign: 'right' }}>
                            {item.calculatedTotal ? item.calculatedTotal.toFixed(2) : (item.qty * item.unitPrice).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <p>Select an invoice to view details</p>
          )}
        </Paper>
      </Grid>

      <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity='success' sx={{ width: '100%' }}>
                    Lottery Returned
                </Alert>
        </Snackbar>

      {/* Third Column: Finalized Bill and Print Option */}
      <Grid item xs={12} md={4}>
        <Paper style={{ padding: '20px', height: '100%' }}>
          <h3>Finalized Bill</h3>
          {selectedInvoice && (
            <>
              <p><strong>Invoice No:</strong> {selectedInvoice.inv_no}</p>
              <p><strong>Original Total:</strong> {parseFloat(selectedInvoice.total).toFixed(2)}</p>
              <p><strong>Final Total:</strong> {finalTotal.toFixed(2)}</p>

              {submitLoading ? <>
                <PulseLoader size = {14} color='#00ffdd' speedMultiplier={1}/>
              </> : <>
                <Button variant="outlined" color="primary"  endIcon={<PrintIcon />} fullWidth onClick={handlePrint}>
                Print 
                </Button>
              </>}

            </>
          )}
        </Paper>
      </Grid>

      <div style={{display : 'none',position : 'relative',zIndex:1000,justifyContent : 'center',top : 0,jeft :0,width : '100%',height : '100%',alignItems : 'center'}}>
        {/* <div style={{position : 'relative',zIndex:1000,justifyContent : 'center',top : 0,jeft :0,width : '100%',height : '100%',alignItems : 'center'}}> */}
        <table border={0} width={'300'} style={{ fontFamily: 'Consolas',backgroundColor : 'white', height : 8,marginLeft : 10 }} id='BillingDoc'  ref={printsRef} >
                   <tr>
                <td colSpan={6} align='center' style={{ fontSize: 14, fontWeight: 'bold' }}><label style={{ fontSize: 18 }}>M.M.Munidasa Lottery Agency<br></br></label>175/23/E, Mahawatta Road, 
                Pelanwatta,<br></br>Pannipitiya<br></br>Tel. (+94) 788 393 515<br></br>RETURN INVOICE</td>
            </tr>
            <tr>
              <td colSpan={6}><hr></hr></td>
            </tr>
            <tr>
              <td colSpan={6}>Distributor : {selectedInvoice?.distributor}</td>
            </tr>
            <tr>
              <td colSpan={6}>Invoice No : {selectedInvoice?.inv_no}</td>
            </tr>
            <tr  align='center'>
                <td colSpan={6} align='left'>Draw Date : {selectedInvoice?.draw_date.split('T')[0]}</td>
            </tr>
            <tr  align='center'>
                <td colSpan={6} align='left'>R Date : {`${year}-${month}-${day}|Time: ${hours}:${minutes}`}</td>
            </tr>
            {selectedIncoiceDetails?.map((e, i) => (
                <>
                <tr>
                    <td align='right'>{i + 1}<>).</></td>
                    <td colSpan={6}>{e.Lottery} </td>
                </tr>
                <tr style={{ backgroundColor: 'white' }}>
                    <td ></td>
                    <td align='right' style={{height : 10}}>{e.remainingQty}</td>
                    <td align='center' colSpan={2}>{parseFloat(e.unitPrice).toFixed(2)}</td>
                    <td align='right' colSpan={2}>{parseFloat(e.calculatedTotal).toFixed(2)}</td>
                </tr>
                </>
                ))}
                <td colSpan={6} align='right'><hr></hr> </td>
                <tr>
                <td align='left' colSpan={3}>T.T. : {remainingQty}</td>
                <td  align='right' colSpan={3} style={{width : 200}}>Total :   Rs.{parseFloat(finalTotal).toFixed(2)}</td>
                </tr>
                <tr>
                </tr>
               
                <tr>
                <td 
                  colSpan={5} 
                  align='center' 
                  style={{ 
                    fontWeight: 'bold', 
                    border: '2px solid black', // Add black border
                    color: 'black', 
                    backgroundColor: 'transparent', // Set background to transparent
                  }}
                >
                 
                  
                  <center>
                  Pending Rs. {(parseFloat(finalTotal) + parseFloat(pending)).toFixed(2)-parseFloat(selectedInvoice?.total)}
                  </center>
                 
                </td>
              </tr>
                <tr>
                <td colSpan={6} align='center' style={{fontSize : 15}}>Provide this when settling the payment!</td>
                </tr>
                <tr>
                <td colSpan={6} align='center'><hr></hr></td>
                </tr>
                <tr>
                <td colSpan={6} align='center' style={{fontSize : 13,fontWeight:'bold',height : 10}}>Software by CC Software Solutions</td>
                </tr>
                <tr>
                <td colSpan={6} align='center' style={{fontSize : 13,fontWeight:'bold'}}>077 0832 340</td>
                </tr>
            </table>
        </div>

    </Grid>
  );
}

export default Returns;
